import { useEffect } from 'react'
import { useRFPDetailsContext } from 'features/RFP/RFPDetails/Providers/RFPDetailsContextProvider'

import './styles.scss'
import { ResponsibleForRFP } from 'features/RFP/RFPDetails/ResponsibleForRFP'
import { FieldWithLabel } from 'components/FieldWithLabel/FieldWithLabel'
import { BiddingFilesUpload } from './BiddingFilesUpload'

export const RFPBidding = () => {
  const rfpDetailsContext = useRFPDetailsContext()

  const { data, biddingData, isVendor, isVendorCanUploadDocuments } =
    rfpDetailsContext.state

  const { handleGetBiddingData } = rfpDetailsContext.actions

  useEffect(() => {
    if (data.uuid) {
      handleGetBiddingData()
    }
  }, [data.uuid, handleGetBiddingData])

  return (
    <div className="rfp-bidding">
      <div className="rfp-bidding__left">
        <div className="rfp-bidding__files">
          <BiddingFilesUpload
            isViewMode={!isVendorCanUploadDocuments}
            biddingData={biddingData}
          />
        </div>
      </div>
      <div className="rfp-details-general__right">
        {isVendor && (
          <FieldWithLabel
            className="mt-24 rfp-bidding__label"
            title="Community contacts"
          />
        )}
        <ResponsibleForRFP isBidding />
      </div>
    </div>
  )
}
